import React from 'react';
import classNames from 'classnames';
import { useTranslation } from '@lt/localization';
import { ButtonTs, ResponsiveModal } from '@lt/components';
import styles from './flightFail.module.css';
import type { ActualizationFrontError } from '../../store/actualization/types';
import {
  FLIGHT_FAIL_CHANGE_FLIGHT_TEST_ID,
  FLIGHT_FAIL_REDIRECT_TO_HOTEL_TEST_ID,
  FLIGHT_FAIL_TEST_ID,
} from './constants';

interface Props {
  frontError: ActualizationFrontError | null;
  isMobile: boolean;
  hotelUrl: string;
  packageId: number;
}

export const FlightFail = (props: Props) => {
  const { frontError, hotelUrl, packageId, isMobile } = props;
  const { t } = useTranslation();

  return (
    <ResponsiveModal
      open={frontError === 'actualize_flight_error'}
      onClose={() => {
        window.location.href = `${window.location.origin}/packages/${packageId}?search_type=package#redirect_flights`;
      }}
      showCloseIcon={false}
      styles={{
        modal: { borderRadius: 6 },
        overlay: { background: 'rgba(0, 0, 0, 0.75)' },
      }}
    >
      <div
        className={classNames(styles.container, {
          [styles.containerMobile]: isMobile,
        })}
        data-testid={FLIGHT_FAIL_TEST_ID}
      >
        <legend
          className={classNames(styles.header, {
            [styles.headerMobile]: isMobile,
          })}
        >
          {t('checkout.redirectFlights.title')}
        </legend>
        <span className={styles.text}>
          {t('checkout.redirectFlights.message')}
        </span>

        <ButtonTs
          size="flex"
          variant="primary"
          data-testid={FLIGHT_FAIL_CHANGE_FLIGHT_TEST_ID}
          className={styles.button}
          onClick={() => {
            window.location.href = `${window.location.origin}/packages/${packageId}?search_type=package#redirect_flights`;
          }}
        >
          {t('checkout.redirectFlights.changeFlight')}
        </ButtonTs>
        <ButtonTs
          size="flex"
          variant="functional"
          data-testid={FLIGHT_FAIL_REDIRECT_TO_HOTEL_TEST_ID}
          className={classNames(styles.button, styles.blue)}
          onClick={() => {
            window.location.href = hotelUrl;
          }}
        >
          {t('checkout.redirectFlights.redirectToHotel')}
        </ButtonTs>
      </div>
    </ResponsiveModal>
  );
};
